// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-form {
  width: 100%;
}

.comment-form-full-width {
  width: 100%;
  height: 150px;
}

.button-row {
  display: flex;
  max-width: 600px;
  gap: 5px;
  padding: 10px 0;
}

main {
  margin: 0;
  background-color: white;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

section {
  width: 100%;
}

textarea {
  resize: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
